import controller from './register.controller';
import template from './register.html';

const shopRegisterComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default shopRegisterComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/shop/register/register.component.js
 **/